import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { AccessGroupService } from '../../../../access-group.service';
import { LmTsService } from '../../../lm-ts.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LambdaFunctionService } from '../../../../../service/lambda-function.service';
import { CustomPfService } from '../../../../custom-profile/custom-pf.service';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
    selector: 'app-learner-map-slideshow',
    templateUrl: './learner-map-slideshow.component.html',
    styleUrls: ['./learner-map-slideshow.component.scss']
})
export class LearnerMapSlideshowComponent implements OnInit, OnChanges, OnDestroy {

    public env = environment;
    public profiles: any;
    public currentCard_id: string;
    @Input() allCols;
    @Input() currentlm;
    @Input() previousCard;
    @Input() nextCard;
    @Input() audio;
    slides: any;
    slides_text: any;
    current_card: any;
    author: any;
    myaudio = '';
    foursightassets: any;
    text_visib = true;
    showHideCards = true;
    audio_mute = false;
    appNoli = false;
    slideshow_id: any = [];
    counter = 0;
    id: string;
    slidemap_visited = true;
    sorted_item: any = [];
    slide_val = 1;
    allitem: any = [];
    call_lmbda = true;
    profile_slideshow;
    slide_no = 1;
    admin_upload = environment.admin_upload;
    placeholderImage = 'assets/images/learner-map-placeholder.svg';
    args: any;
    lm_type: string;
    showLoader = true;
    showExpireModal = false;

    private destroy$ = new Subject<void>();

    constructor(
        private modalService: NgbModal,
        public accessgroup: AccessGroupService,
        public http: HttpClient,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public lm_ts: LmTsService,
        public lmda_service: LambdaFunctionService,
        public customPfService: CustomPfService,
        public location: Location,
        public store: Store<any>
    ) {}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onImgError(event: Event) {
        const img = event.target as HTMLImageElement;
        if (img && img.src !== this.placeholderImage) {
            img.src = this.placeholderImage;
        }
    }

    /** Extract plain string from a value that may be DynamoDB format {S: 'val'} or a plain string */
    str(val: any): string {
        if (!val) return '';
        return val?.S ?? val ?? '';
    }

    /** Normalize currentlm fields to plain strings so template comparisons work consistently */
    private normalizeCurrentLm() {
        if (!this.currentlm) return;
        if (this.currentlm.kind && typeof this.currentlm.kind === 'object') {
            this.currentlm.kind = this.str(this.currentlm.kind);
        }
        if (this.currentlm.link && typeof this.currentlm.link === 'object') {
            this.currentlm.link = this.str(this.currentlm.link);
        }
        if (this.currentlm.title && typeof this.currentlm.title === 'object') {
            this.currentlm.title = this.str(this.currentlm.title);
        }
        if (this.currentlm.text && typeof this.currentlm.text === 'object') {
            this.currentlm.text = this.str(this.currentlm.text);
        }
        if (this.currentlm.background && typeof this.currentlm.background === 'object') {
            this.currentlm.background = this.str(this.currentlm.background);
        }
        if (this.currentlm.bg && typeof this.currentlm.bg === 'object') {
            this.currentlm.bg = this.str(this.currentlm.bg);
        }
    }

    /** Check if current slide has a known type that has a matching template handler */
    isKnownSlideType(): boolean {
        const kind = this.currentlm?.kind?.S || this.currentlm?.kind || '';
        // Only types that have actual *ngIf blocks in the template
        const handledTypes = [
            'Var_Welcome', 'Var_Brief', 'Var_Universal_Process',
            'Var_Universal_Process_Clarify', 'Var_Universal_Process_Ideate',
            'Var_Universal_Process_Develop', 'Var_Universal_Process_Implement',
            'Var_STATIC', 'Var_RESULTS', 'Var_FS_GRAPH',
            'Var_Stages', 'Var_Stages_Clarify', 'Var_Stages_Clarify_Score',
            'Var_Stages_Ideate', 'Var_Stages_Ideate_Score',
            'Var_Stages_Develop', 'Var_Stages_Develop_Score',
            'Var_Stages_Implement', 'Var_Stages_Implement_Score',
            'Var_What_Should_You_Know', 'Var_Profile',
            'Var_Work_Well_With_Other', 'Var_Thank_You',
            'Var_SLIDEMAP', 'VAR_Video_full', 'Var_Video_MP4',
            'Var_Wistia', 'Var_Img_no_title', 'video'
        ];
        return handledTypes.includes(kind);
    }

    @HostListener('document:keydown', ['$event'])
    onkeydown(event: KeyboardEvent): void {
        if (event.keyCode === 37 || event.keyCode === 33) {
            this.appNoliPreNext('prev');
        }
        if (event.keyCode === 39 || event.keyCode === 34) {
            this.appNoliPreNext('next');
        }
    }

    ngOnInit() {
        this.appNoli = this.router.url.includes('thinking-coach');

        if (!this.appNoli) {
            this.hideCards();
            this.initMainApp();
        } else {
            this.initAppNoli();
        }

        this.normalizeCurrentLm();
        this.current_card = this.currentlm;
        this.slides_data(this.currentlm);
        this.initAuthorAndAssets();
    }

    private initMainApp() {
        this.lamda_appData();
        this.myaudio = this.str(this.currentlm?.link);

        // Redirect if access is not permitted
        this.store.select<any>((state) => state.profile.accessGroupData).pipe(
            takeUntil(this.destroy$),
            filter(message => !!message)
        ).subscribe(message => {
            if (message['main_menu']?.profile?.profile_slideshow?.slideshow !== true) {
                this.router.navigate(['/dashboard']);
            }
        });

        // Listen for slide changes
        this.lm_ts.an_slide_no.pipe(
            takeUntil(this.destroy$)
        ).subscribe(val => {
            try {
                this.slide_val = val;
                this.slide_no = val + 1;
                this.currentlm = this.sorted_item[val];
                if (this.currentlm) {
                    this.normalizeCurrentLm();
                    this.current_card = this.currentlm;
                    this.slides_data(this.currentlm);
                }
            } catch (e) {
                // Prevent subscriber from dying on error
            }
        });

        // Build slideshow ID list from columns
        if (this.slideshow_id.length < 1 && this.allCols?.allcolumns) {
            this.allCols.allcolumns.forEach(column => {
                (column.cards?.items || column.cards || []).forEach((card: any) => {
                    this.slideshow_id.push(card?.id);
                });
            });
        }

        // Get profile data
        this.http.get(`${environment.profileURL}/api/v1/profiles.json`, { params: { lang: 'en' } }).pipe(
            takeUntil(this.destroy$)
        ).subscribe(res => {
            if (res != null) {
                for (let i = 0; i < res['profiles'].length; i++) {
                    if (res['profiles'][i].default === true) {
                        this.profiles = res['profiles'][i];
                    }
                }
            }
        });
    }

    private initAppNoli() {
        // FS Profile Fetch Service (thinking-coach mode)
        this.store.select<any>((state) => state.profile.tcwaProfile).pipe(
            takeUntil(this.destroy$),
            filter(res => !!res)
        ).subscribe(res => {
            if (res?.status === 422) {
                this.showExpireModal = true;
            }
            this.profiles = res['profile'];
            this.slides_data(this.currentlm);
        });

        this.slide_no = this.currentlm?.position ?? 1;

        // Slidemap Cards Data - Lambda
        if (this.call_lmbda) {
            this.call_lmbda = false;
            this.lambda_lmdata();
        }

        // Listen for slide changes in appNoli mode
        this.lm_ts.an_slide_no.pipe(
            takeUntil(this.destroy$)
        ).subscribe(val => {
            this.slide_val = val;
            this.currentlm = this.sorted_item[val];
            this.normalizeCurrentLm();
            this.current_card = this.currentlm;
            this.slides_data(this.currentlm);
        });
    }

    private initAuthorAndAssets() {
        this.author = {
            image: 'author-pic.jpg',
            smallLogo: 'foursight-grey-logo-logotype-trans-w160.png',
            logoicon: 'foursight-grey-logo-icon.png',
            logotext: 'foursight-grey-logo-text.png',
            logoFoursight: 'foursight-grey-logo-logotype-trans-w846.png',
            audio: this.str(this.currentlm?.link),
            lm_audio: true,
        };

        this.foursightassets = {
            clarifyImage: 'clarify-icon-2.png',
            titleClarify: 'Clarify',
            ideateImage: 'ideate-icon-2.png',
            titleIdeate: 'Ideate',
            developImage: 'develop-icon-2.png',
            titleDevelop: 'Develop',
            implementImage: 'impl-icon-2.png',
            titleImplement: 'Implement'
        };
    }

    public ngOnChanges() {
        this.normalizeCurrentLm();
        this.initAuthorAndAssets();
        this.mute(this.audio_mute);

        this.current_card = this.currentlm;

        // Rebuild slides array so Wistia/video slide data is current
        if (this.currentlm) {
            this.slides_data(this.currentlm);
        }

        // Open slidemap cards in appNoli mode
        if (this.current_card?.kind === 'Var_SLIDEMAP' && this.appNoli) {
            this.slidemap_visited = false;
        }

        this.slide_no = (this.lm_ts.an_slide_no?.getValue?.() ?? 0) + 1;
    }

    // hide/show learner map cards
    public hideCards() {
        const cards = document.querySelector('.course-index') as HTMLElement;
        if (this.showHideCards) {
            if (this.appNoli) {
                const appNoli_cards = document.querySelector('.all-learner-maps.lm-an-cards') as HTMLElement;
                if (appNoli_cards) appNoli_cards.style.display = 'none';
            } else {
                if (cards) cards.style.display = 'block';
            }
        } else {
            if (this.appNoli) {
                const appNoli_cards = document.querySelector('.all-learner-maps.lm-an-cards') as HTMLElement;
                if (appNoli_cards) appNoli_cards.style.display = 'flex';
            } else {
                if (cards) cards.style.display = 'none';
            }
        }
        this.showHideCards = !this.showHideCards;
    }

    // show hide text/subtitle
    public showHideText() {
        this.text_visib = !this.text_visib;
    }

    // mute audio globally
    public mute(val: boolean) {
        this.audio_mute = val;
        const audioElements = document.querySelectorAll('audio');
        audioElements.forEach(audio => {
            audio.muted = val;
        });
    }

    // appnoli previous next button
    public appNoliPreNext(step: string) {
        const id = this.activatedRoute.snapshot.params.id;

        if (step === 'prev') {
            this.slide_val = this.slide_val - 1;
            if (this.slide_val < 0) {
                this.slide_val = this.sorted_item.length - 1;
                if (this.appNoli) {
                    this.customPfService.trackActivity(id, 'profile_slide_map_finish');
                }
            }
        }
        if (step === 'next') {
            this.slide_val = this.slide_val + 1;
            if (this.slide_val === this.sorted_item.length - 1 && this.appNoli) {
                this.customPfService.trackActivity(id, 'profile_slide_map_finish');
            }
            if (this.slide_val > this.sorted_item.length - 1) {
                this.slide_val = 0;
            }
        }

        this.lm_ts.an_slide_no.next(this.slide_val);
    }

    // change slide for appNoli
    public changeSlide() {
        const id = this.activatedRoute.snapshot.params.id;

        if (this.slide_no - 1 === 0) {
            this.customPfService.trackActivity(id, 'profile_slide_map_start');
        }
        if (this.slide_no - 1 === this.sorted_item.length - 1) {
            this.customPfService.trackActivity(id, 'profile_slide_map_finish');
        }

        if ((this.slide_no - 1) >= this.sorted_item.length) {
            this.slide_no = this.sorted_item.length;
        } else if ((this.slide_no - 1) < 1) {
            this.slide_no = 1;
        }
        this.lm_ts.an_slide_no.next(this.slide_no - 1);
    }

    public lm_pre_next() {
        this.slide_no = this.currentlm.position + 1;
    }

    // change slide for learnermap
    public changeSlideUrl() {
        this.router.navigate(['/learner-maps/' + this.allCols.currentLM_id + '/card/' + this.slideshow_id[this.slide_no - 1]]);
    }

    // getting learner map data for main app
    public lamda_appData() {
        const url = this.router.url;
        const segments = url.split('/');
        const id = segments[2] || '';

        this.args = { lm_id: id };

        if (!this.router.url.includes('profile-slideshow') && this.args.lm_id !== 'presentation') {
            this.args['compName'] = 'lm-slideshow';
            this.lmda_service.lambda_invoke('read-dynamoDb-data', this.args);
        }

        this.lmda_service.lambda_res.pipe(
            takeUntil(this.destroy$),
            filter(res => res?.length > 0)
        ).subscribe(res => {
            this.sorted_item = [];
            this.slideshow_id = [];
            this.allitem = [];

            const allcolumns = [...res].sort((a, b) => a?.position - b?.position);

            allcolumns.forEach(col => {
                const sortedCards = (col['learner_map_cards'] || []).sort((a, b) => a.position - b.position);
                sortedCards.forEach((card: any) => {
                    this.allitem.push(card);
                });
            });

            const sorting: any = [];
            this.allitem.forEach(element => {
                sorting[parseInt(element.position) - 1] = element;
            });

            this.allitem.forEach((el: any) => {
                if (el?.active !== false) {
                    this.sorted_item.push(el);
                    this.slideshow_id.push(el.id);
                }
            });

            this.currentlm = this.sorted_item[0];
            this.normalizeCurrentLm();
            this.current_card = this.currentlm;
            this.slides_data(this.currentlm);
            this.showLoader = false;
        });
    }

    // lambda function getting cards data for TCWA
    public lambda_lmdata() {
        this.slide_no = 1;

        this.customPfService.active_lmsd_id.pipe(
            takeUntil(this.destroy$)
        ).subscribe(val => {
            this.lmda_service.lambda_res.pipe(
                takeUntil(this.destroy$),
                filter(res => !!res && Array.isArray(res) && res.length > 0)
            ).subscribe(res => {
                this.sorted_item = [];
                this.slideshow_id = [];
                this.allitem = [];

                const allcolumns = res;
                let counter = 0;

                allcolumns.forEach(col => {
                    (col['learner_map_cards'] || []).forEach(card => {
                        this.allitem.push(card);
                    });
                });

                const sorting: any = [];
                this.allitem.forEach((element: any) => {
                    sorting[parseInt(element.position) - 1] = element;
                });

                sorting.forEach(el => {
                    if (el?.active !== false) {
                        this.sorted_item.push(el);
                        this.slideshow_id.push(el.id);
                    }
                });

                // Update currentlm after sorted_item is populated
                if (this.sorted_item.length > 0) {
                    const idx = this.slide_val || 0;
                    this.currentlm = this.sorted_item[idx];
                    this.normalizeCurrentLm();
                    this.current_card = this.currentlm;
                    this.slides_data(this.currentlm);
                }

                this.showLoader = false;
            });
        });
    }

    // Get new 7-day link for thinking-coach
    public changeUrl() {
        window.location.replace(`${this.env.assessment_admin}/thinking-coach`);
    }

    // full screen
    public fullScreen() {
        document.body.classList.add('full-scr');
    }

    // exit from full screen
    public exitFullScreen() {
        document.body.classList.remove('full-scr');
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    public slides_data(val: any = '') {
        const title = this.str(this.currentlm?.title);

        this.slides_text = {
            1: {
                title: '',
                below_text: ["You know the expression \u201CGreat minds think alike?\u201D Actually, they don\u2019t.", "I\u2019m Sarah Thurber, managing partner at FourSight, where we study cognitive diversity in problem solving. In our database of hundreds of thousands of thinking profiles, not many people have a profile quite like yours."],
            },
            2: {
                title: 'How do you approach a challenge?',
                below_text: ["The FourSight assessment is a scientific measure of thinking preference. It reveals how you naturally approach any kind of challenge that needs new thinking. It helps you reflect on your own problem-solving style and understand why others approach the same problem so differently. In the next 10 minutes, my goal is to give you information about your thinking profile that can make you an even more effective problem solver and collaborator."],
            },
            3: {
                title: 'The Universal Process ',
                below_text: ["How exactly do people solve complex challenges? There are lots of useful models out there. But they all rely on bringing together four distinct types of thinking. Put them together, and you get a simple, universal, problem-solving process. We call it the FourSight framework."],
            },
            4: {
                title: 'The universal process',
                below_text: ["First, you clarify to understand the challenge."],
            },
            5: {
                title: 'The universal process',
                below_text: ["Then, you ideate to imagine new ideas to solve the challenge."],
            },
            6: {
                title: 'The universal process',
                below_text: ["Next, you develop workable solutions."],
            },
            7: {
                title: 'The universal process',
                below_text: ["And you implement them.  Success requires all four types of thinking. So you\u2019d think we would use them all equally.", "But we don\u2019t."],
            },
            8: {
                title: 'FourSight thinking preferences',
                below_text: ["Through 20 years of research and analyzing more than six million data points on cognitive diversity, Professor Gerard Puccio from the State university of New York College at Buffalo discovered that more than 80% of us prefer some types of thinking over others. He called those thinking preferences. Thinking preferences are hard to see, but they can cause a lot of stress in relationships. They\u2019re often the underlying cause of misunderstanding, frustration and miscommunication. Ever noticed how some people seem to ask too many questions? Or have too many ideas? Or make things too complicated? Or rush to finish things too quickly? Those are thinking preferences in action. The ones you don\u2019t like are probably the ones you don\u2019t share. We\u2019re used to our own thinking preferences, but other people\u2019s can be a little hard to take, especially when we don\u2019t understand where they\u2019re coming from."],
            },
            9: {
                title: 'Preference does not equal ability',
                below_text: ["Now, when we\u2019re talking about thinking preferences, there\u2019s one thing you should know: Thinking preferences are NOT the same as thinking abilities. You have the ability to do all four types of thinking, and you do them all the time. But if you\u2019re like most people, your brain plays favorites. Some styles of thinking may come more naturally. Some energize you more. Those are your thinking preferences, which remain pretty constant over a life time. Your thinking abilities, however, can change and improve with training and practice."],
            },
            10: {
                title: 'There are no \u201Cgood\u201D or \u201Cbad\u201D scores',
                below_text: [" Given that FourSight measures your preferences, it follows that you can\u2019t possibly get a \u201Cbad\u201D score on this measure. Because it\u2019s simply a measure of how much you like something. FourSight has 15 different thinking profiles. So the best profile really is your profile. Because it shows where you naturally light up in the <b>problem-solving</b> process. The goal is not to change your profile, but to understand it. So remember, a high score isn\u2019t a good score any more than a low score is a bad score. It\u2019s just an indication of where you like to spend time and energy."],
            },
            11: {
                title: 'Congratulations!',
                "Clarifier": {
                    below_text: "You have a high preference for clarifying.",
                    Clarifier: 'That\u2019s fantastic news. Clarifiers are known for understanding what problem to solve.',
                },
                "Ideator": {
                    below_text: 'You have a high preference for ideating.',
                    Ideator: 'That\u2019s fantastic news. Ideators are known for generating original ideas.',
                },
                "Developer": {
                    below_text: 'You have a high preference for developing.',
                    Developer: 'That\u2019s fantastic news. Developers are known for polishing and perfecting plans.',
                },
                "Implementer": {
                    below_text: 'You have a high preference for implementing.',
                    Implementer: 'That\u2019s fantastic news. Implementers are known for their persistence to make things happen.',
                },
                "Early Bird": {
                    below_text: 'You have a high preference for clarifying and ideating.',
                    Early_Bird: 'That\u2019s fantastic news. Early Birds are known for their strategic insights.',
                },
                "Analyst": {
                    below_text: 'You have a high preference for clarifying and developing.',
                    Analyst: 'That\u2019s fantastic news. Analysts are known for their ability to think things all the way through.',
                },
                "Accelerator": {
                    below_text: 'You have a high preference for clarifying and implementing.',
                    Accelerator: 'That\u2019s fantastic news. Accelerators are known for identifying problems and taking care of them.',
                },
                "Theorist": {
                    below_text: 'You have a high preference for ideating and developing.',
                    Theorist: 'That\u2019s fantastic news. Theorists are known for creating elegant, original solutions.',
                },
                "Finisher": {
                    below_text: 'You have a high preference for ideating and implementing.',
                    Finisher: 'That\u2019s fantastic news. Drivers are known for their ability to turn ideas into reality.',
                },
                "Driver": {
                    below_text: 'You have a high preference for developing and implementing.',
                    Driver: 'That\u2019s fantastic news. Finishers are known for executing complex solutions.',
                },
                "Hare": {
                    below_text: 'You have a high preference for clarifying, ideating and developing.',
                    Hare: 'That\u2019s fantastic news. Hares are known for facilitating complex challenges.',
                },
                "Idea Broker": {
                    below_text: 'You have a high preference for clarifying, ideating and implementing.',
                    Idea_Broker: 'That\u2019s fantastic news. Idea Brokers are known for seizing strategic opportunities.',
                },
                "Optimist": {
                    below_text: 'You have a high preference for ideating, developing and implementing.',
                    Optimist: 'That\u2019s fantastic news. Optimists are known for delivering original solutions.',
                },
                "Integrator": {
                    below_text: ["Congratulations! Your FourSight Thinking Profile is Integrator. You have nearly equal preference for all four stages of problem solving. That\u2019s fantastic news. Integrators are known for their even-handed approach."]
                },
                "Realist": {
                    below_text: 'You have a high preference for clarifying, developing and implementing.',
                    Realist: 'That\u2019s fantastic news. Realists are known for delivering targeted results.',
                },
            },
            12: {
                title: 'Your FourSight Thinking Profile graph',
                "not equal to integrator": {
                    below_text: ['Here\u2019s your graph. It has four scores, one for clarify, ideate, develop and implement.', 'Notice the gray band that runs horizontally across the graph. That represents your neutral zone.', 'Any point that falls above it is a high preference for you. Any point that falls below it is a low preference. Points that within it areneutral preferences. The neutral zone falls in a different place on the graph for every person,because we calculate it based on your highest and lowest scores.', '<strong>The most important part of the graph are not the scores themselves, but the shape of the line that connects them. Think of that as an energy wave, showing how your energy rises and falls</strong>', 'over the course of the problem-solving process. The more extreme the peaks and valleys of your graph, the stronger your preferences.']
                },
                "equal to integrator": {
                    below_text: ['Here\u2019s your graph. It has four scores, one for clarify, ideate, develop and implement.', 'Notice the gray band that runs horizontally across the graph. That represents your neutral zone.', 'Any point that falls above it is a high preference for you. Any point that falls below it is a low preference. Points that within it areneutral preferences. The neutral zone falls in a different place on the graph for every person,because we calculate it based on your highest and lowest scores.', 'The most important part of the graph are not the scores themselves, but the shape of the line that connects them. Think of that as an energy wave, showing how your energy rises and falls', 'over the course of the <b>problem-solving</b> process. The more extreme the peaks and valleys of your graph, the stronger your preferences.']
                }
            },
            13: {
                title: "The 4 stages",
                below_text: ["I\u2019ll walk you through your scores one at a time. First we\u2019ll look at each stage of the universal process. Then we\u2019ll look at your preference for it."]
            },
            14: {
                title: "Clarify",
                below_text: [" We start with clarifying. This is the stage where you do the reality check. You figure out what is going on and ask all the who, what, when, where, why and how questions. The goal of clarifying is to understand the situation well enough that you can truly identify what challenge you should be trying to address."]
            },
            15: {
                "Your preference for clarifying = High": {
                    title: 'Your preference for clarifying = High',
                    below_text: ["It looks like you have a high preference for clarifying. Our research shows that high Clarifiers instinctively focus on understanding the challenges they take on. You pursue information, get background data, and familiarize yourself with rules, directions and instructions to crystalize your understanding. While some people go rushing into ideas and solutions, you move forward cautiously, thinking about the right way to approach the challenge and asking questions to make sure you are on target. People with a low preference for clarifying may sometimes see you as being overly cautious or stuck in \u201Canalysis paralysis,\u201D but you would rather spend time thinking things through up front to make sure you\u2019re solving the right problem."]
                },
                "neutral and not equal to integrator": {
                    title: 'Your preference for clarifying = Neutral',
                    below_text: ["It looks like you have a neutral preference for clarifying. When faced with an open-ended challenge, you naturally gather key information, get familiar with the rules, restrictions and expectations and move forward. While people with a high preference for clarifying may keep gathering more and more information, you are comfortable moving forward, even in the face of some ambiguity. Your neutral position makes it possible for you to work with both high and low Clarifiers with relative ease."]
                },
                "Your preference for clarifying = Low": {
                    title: 'Your preference for clarifying = Neutral',
                    below_text: [" It looks like you have a low preference for clarifying. That means you tend to move quickly through the clarifying stage. You need to gather only the essential pieces of information before you are ready to move to other parts of the process. You don\u2019t need all the details now, because you are willing to backfill the information later, when it\u2019s clear what information is really necessary. In your rush to move on, you may miss key pieces of information and find your subsequent efforts unfocused or off target. Then again, your willingness to move ahead in the face of ambiguity allows you to discover information down the line that no amount of thinking or research could produce up front."]
                },
                "neutral and equal to integrator": {
                    title: 'INTEGRATOR -- You score \u201Cneutral\u201D for clarify',
                    below_text: [" As an integrator, you have a neutral preference for clarifying. When faced with an open-ended challenge, you naturally gather key information, get familiar with the rules, restrictions and expectations and move forward. While people with a high preference for clarifying may keep gathering more and more information, you are comfortable moving forward, even in the face of some ambiguity. Your neutral position makes it possible for you to work with both high and low Clarifiers with relative ease."]
                }
            },
            16: {
                title: 'ideate',
                below_text: ['The next stage in the universal <b>creative</b> process is the Ideate stage. Here\u2019s where you generate ideas, drum up possibilities, explore options and make new connections. Let your brain float above the facts \u201Cas given\u201D and see the big picture. This is your chance to use your imagination to challenge rules, reverse assumptions, make intuitive leaps\u2026all in hopes of striking on ideas that are novel and valuable. <b> This is the stage that we associate with thinking outside the box.</b>']
            },
            17: {
                "Your preference for ideating = High": {
                    title: 'Your preference for clarifying = High',
                    below_text: ["When it comes to ideating, it looks like you have a high preference. Our research shows that high Ideators love to generate ideas. In fact, sometimes, you can\u2019t STOP generating ideas. Your thinking is naturally fluent, flexible and prolific. You see things in global terms and need to know \u201Cwhy something is important\u201D before you are willing to engage. You can use your imagination to envision futures different than what\u2019s before you. Your appetite for novelty lets you enjoy variety, surprises and new experiences. Conversely, you are likely to avoid monotonous, repetitive, predictable activities. You don\u2019t mind defying convention and sometimes enjoy the attention that brings. Your attention is drawn to to so many different things, to others your thinking can sometimes seems fractured or distracted. Then you\u2019ll surprise them by making a connection that everyone else missed."]
                },
                "neutral and not equal to integrator": {
                    title: 'Your preference for ideating = Neutral',
                    below_text: [" When it comes to ideating, it looks like you have a neutral preference. So when it\u2019s time to generate ideas, you may think up some options and choose the best one. The choice doesn\u2019t have to be ground-breaking, earth-shattering or even new, as long as you think it will work. High Ideators will keep for pushing novelty and low Ideators will avoid novelty. But your neutral position makes it relatively easy to work with people at both ends of the Ideator spectrum."]
                },
                "Your preference for ideating = Low": {
                    title: 'Your preference for ideating = Low',
                    below_text: ["When it comes to ideating, it looks like you have a low preference. Low Ideators can move quickly through the ideation stage, because you don\u2019t feel compelled to challenge the status quo or produce a dozen dazzling new ideas. You just need one workable idea. A functional, reliable, sure-fire idea so you can get back to the more \u201Cserious\u201D parts of the process. The hazard of shortchanging the ideation stage is that you are likely to end up with a solution that is rather conventional. Still, there are a lot of challenges where your simple, pragmatic approach to ideation is enough to get the job done."]
                },
                "neutral and equal to integrator": {
                    title: 'INTEGRATOR -- You score \u201Cneutral\u201D for ideate',
                    below_text: [" When it\u2019s time to generate ideas, your neutral preference for ideating helps you steadily think up options and choose the best one. The choice doesn\u2019t have to be ground-breaking, earth-shattering or even new, as long as you think it will work. High Ideators will keep for pushing novelty and low Ideators will avoid novelty. But your neutral position makes it relatively easy to work with people at both ends of the Ideator spectrum."]
                }
            },
            18: {
                title: "Develop",
                below_text: ["Now we come to the Develop stage. This is where ideas and concepts get worked out and improved, where they are moved from rough ideas into refined solutions. Developing means weighing the pros and cons of competing options, analyzing choices, optimizing solutions, and refining plans. Think of this as the stage where you create a blueprint of the perfect solution."]
            },
            19: {
                "Your preference for developing = High": {
                    title: 'Your preference for clarifying = High',
                    below_text: [" It looks like you have a high preference for developing. High Developers seem to enjoy the patient work of refining and polishing solutions. You know that perfecting things takes time. You are reflective, cautious and pragmatic, and you appreciate having time and space to sort out your options and elaborate on your plans. High developers enjoy crafting complex multi-layered solutions. You may have a perfectionist streak that can make it hard to meet the standards that you set. But when you succeed, everyone appreciates the result."]
                },
                "neutral and not equal to integrator": {
                    title: 'Your preference for ideating = Neutral',
                    below_text: [" When it comes to developing, it looks like you have a neutral preference. A neutral score for developing suggests that when it\u2019s time to develop solutions, you pick the best ideas and refine them until you have a practical plan to implement. That approach may seem obvious to you, but people with high and low preferences for developing are quite different. Those with a high preferences get drawn into every detail of the plan. Those with a low preference may resist planning all together and prefer to rush right into implementation. Your neutral position makes a good bridge between high and low Developers."]
                },
                "Your preference for developing = Low": {
                    title: 'Your preference for developing = Low',
                    below_text: ["It looks like you have a low preference for developing. Low Developers can move quickly through the develop stage. You may prefer a simple, working plan that will allow maximum flexibility responsiveness. Itineraries and minute-to-minute agendas can bog you down. Frankly, the less time spent fussing over the perfect solution the better. Your impatience with developing may cause bumps in the road when you implement, but you\u2019d rather risk a journey of discovery than suffer through crafting the perfect solution!"]
                },
                "Neutral and equal to integrator": {
                    title: "INTEGRATOR -- You score \u201Cneutral\u201D for develop ",
                    below_text: [" Your neutral score here suggests that when it\u2019s time to develop solutions, you pick the best ideas and refine them until you have a practical plan to implement. That approach may seem obvious to you, but people with high and low preferences for developing are quite different. Those with a high preferences get drawn into every detail of the plan. Those with a low preference may resist planning all together and prefer to rush right into implementation. Your neutral position makes a good bridge between high and low Developers."]
                }
            },
            20: {
                title: 'implement',
                below_text: ["And finally, we get to the implement stage. This is where you make things happen. As the Nike motto says: Just do it. You take your solution and put it into action. You build it, test it, sell it or make it happen.  The implementation stage is about results. Everything else was a pre-amble. Now it\u2019s time to get the job done."]
            },
            21: {
                "High": {
                    title: "Your preference for implementing = High",
                    below_text: [" When it comes to implementing, it looks like you have a high preference for this part of the process. High Implementers have a strong bias for action. Ready or not, you push toward your goal, and everything else falls away. You are confident selling your ideas to others. You tend to be persistent, decisive, determined and assertive. And others better move just as fast as you do, or you\u2019ll just do the work yourself. In your haste to act, be careful not to fall victim to a \u201Cready, fire, aim\u201D syndrome, where you haven\u2019t thought things through. No need to rush. Be confident that as a high Implementer, if there\u2019s a way to deliver results, you\u2019ll do it!"]
                },
                "neutral and not equal to integrator": {
                    title: "Your preference for implementing = Neutral",
                    below_text: ["When it comes to implementing, it looks like you have a neutral preference, suggesting that you move into action when the time comes. While people with high preferences may leap into action before thinking things through, and people with a low preference may avoid and delay action altogether, your neutral position makes it easy for you to get the job done and to work with people on both the high and low ends of the Implementer spectrum."]
                },
                "Low": {
                    title: 'Your preference for implementing = Low',
                    below_text: [" When it comes to implementing, it looks like you have a low preference for this part of the process. Low Implementers don\u2019t seek out busy work or activity for its own sake. Nor are they in a rush to take action. Of course, you still get things done, but sometimes, it may help you to have a deadline or some external support to do it. Your low preference for implementing can help high implementers avoid rushing to action too quickly."]
                },
                "Neutral and equal to integrator": {
                    title: "INTEGRATOR -- You score \u201Cneutral\u201D for implement",
                    below_text: ["When it comes to implementing, once again, your neutral preference, suggesting that you pace yourself and move into action when the time comes. While people with high preference for implementing may leap to action before thinking things through, and people with a low preference may avoid and delay action, your neutral position makes it easy for you to get the job done and to work with people on both the high and low ends of the Implementer spectrum."]
                }
            },
            22: {
                title: "What you should know",
                below_text: ["Now that we\u2019ve gone through each one of your scores, here are some things to keep in mind about your overall profile."]
            },
            23: {
                title: "What you should know",
                below_text: ["need 14 other profiles"]
            },
            24: {
                title: "What\u2019s next?",
                below_text: ["So what\u2019s next? Now that you know about your thinking preferences, you know that sometimes they work for you, and sometimes, they work against you.", " Start by paying attention to thinking preferences in action. Do they drive you to make better decisions or worse ones? Instead of letting your thinking preferences drive your path through the problem-solving process, learn tools and techniques so you can do each stage better, and put your skills not your preferences in the driver seat."]
            },
            25: {
                title: "Work well with others",
                below_text: ["When you work with others, remember that it\u2019s usually easy to work with people like you. People with similar profiles tend to think in the same patterns and get energized by the same things. But over time, they can overlook the same steps and get hung up in the same places. Cognitive diversity actually promotes innovation.", "So there\u2019s real value in learning to work with people who have different thinking profiles. While unrecognized differences can cause stress and conflict, understanding differences can actually improve your performance, especially on complex, long term projects. Use FourSight to help you appreciate the energy and insights other people bring to different parts of the process."]
            },
            26: {
                title: "Create your collaboration profile",
                below_text: ["n our experience, most people are really proud of their FourSight profile, and they want to share it with others. So, being innovators, we\u2019ve developed a way for you to do that. It\u2019s called a collaboration profile. You\u2019ll find it on your FourSight learner map.", " The collaboration profile shows your FourSight profile and gives you a place to add tips for what does and doesn\u2019t work well for you when you collaborate with others.", "Share it with people you problem solve with and invite them to take FourSight. Building this awareness in the groups you work with will help you strengthen both your working relationships and your performance results."]
            },
            27: {
                title: "Keep developing your thinking skills",
                below_text: ["Thank you for taking the FourSight Thinking Profile. It\u2019s our privilege to share this research with you. And we hope you share it with others. We wish you great success as you <b>solve whatever challenges lie ahead.</b>"]
            }
        };

        this.slides = [
            {
                id: 0,
                title: title,
                slideBackgroundImage: "feed-banner.png",
                active: true,
                audio_link: this.admin_upload + '135/original.mp3?1650368969',
                from: "learnermap slideshow"
            }, {
                id: 1,
                title: title,
                slideBackgroundImage: "slide2.jpg",
                audio: 16,
                active: true,
                audio_link: this.admin_upload + '136/original.mp3?1650369297',
            }, {
                id: 2,
                title: title,
                active: true,
                audio_link: this.admin_upload + '138/original.mp3?1650369510',
            }, {
                id: 3,
                title: title,
                active: true,
                audio_link: this.admin_upload + '139/original.mp3?1650369811',
            }, {
                id: 4,
                title: title,
                active: true,
                audio_link: this.admin_upload + '140/original.mp3?1650369871',
            }, {
                id: 5,
                title: title,
                active: true,
                audio_link: this.admin_upload + '141/original.mp3?1650369926',
            }, {
                id: 6,
                title: title,
                active: true,
                audio_link: this.admin_upload + '137/original.mp3?1650369393',
            }, {
                id: 7,
                title: title,
                slideBackgroundImage: "think-pref.png",
                active: true,
                audio_link: this.admin_upload + '142/original.mp3?1650370011',
            }, {
                id: 8,
                title: title,
                slideBackgroundImage: "feed-bulb.png",
                active: true,
                audio_link: this.admin_upload + '143/original.mp3?1650370074',
            }, {
                id: 9,
                title: title,
                slideBackgroundImage: "feed-bulb.png",
                active: true,
                audio_link: this.admin_upload + '144/original.mp3?1650370289',
            }, {
                id: 10,
                title: title,
                profileSubText: "Your FourSight Thinking Profile is",
                active: true,
                audio_link: [
                    '',
                    this.admin_upload + '145/original.mp3?1650370401',
                    this.admin_upload + '146/original.mp3?1650370457',
                    this.admin_upload + '147/original.mp3?1650370524',
                    this.admin_upload + '148/original.mp3?1650370579',
                    this.admin_upload + '149/original.mp3?1650370793',
                    this.admin_upload + '150/original.mp3?1650370850',
                    this.admin_upload + '151/original.mp3?1650370916',
                    this.admin_upload + '152/original.mp3?1650371120',
                    this.admin_upload + '153/original.mp3?1650371187',
                    this.admin_upload + '154/original.mp3?1650371243',
                    this.admin_upload + '155/original.mp3?1650371311',
                    this.admin_upload + '156/original.mp3?1650371368',
                    this.admin_upload + '157/original.mp3?1650371418',
                    this.admin_upload + '158/original.mp3?1650371513',
                    this.admin_upload + '159/original.mp3?1650371566',
                ],
                text: []
            }, {
                id: 11,
                title: title,
                active: true,
                audio_link: [
                    this.admin_upload + '160/original.mp3?1650371716',
                    this.admin_upload + '161/original.mp3?1650371938'
                ]
            }, {
                id: 12,
                title: title,
                active: true,
                audio_link: this.admin_upload + '202/original.mp3?1650438184'
            }, {
                id: 13,
                title: title,
                active: true,
                subtext: "This is the stage when you:",
                list: [
                    { listItem: "understand the situation" },
                    { listItem: "get the facts, background, details" },
                    { listItem: "frame the challenge" }
                ],
                audio_link: this.admin_upload + '162/original.mp3?1650372155',
            }, {
                id: 14,
                title: title,
                active: true,
                highList: [
                    { listItem: "seek information" },
                    { listItem: "ask questions for clarity" },
                    { listItem: "focus on the right problem to solve" },
                    { listItem: "may over analyze" }
                ],
                neutralList: [
                    { listItem: "gather key information" },
                    { listItem: "understand rules, restrictions" },
                    { listItem: "move forward" }
                ],
                lowList: [
                    { listItem: "move quickly through clarifying" },
                    { listItem: "just get the essential data" },
                    { listItem: "gather more data later" },
                    { listItem: "may miss important information" }
                ],
                audio_link: [
                    this.admin_upload + '163/original.mp3?1650372208',
                    this.admin_upload + '164/original.mp3?1650372275',
                    this.admin_upload + '165/original.mp3?1650372330',
                    this.admin_upload + '166/original.mp3?1650372386',
                ]
            }, {
                id: 15,
                title: title,
                active: true,
                subtext: "This is the stage when you:",
                list: [
                    { listItem: "play with ideas and possibilities" },
                    { listItem: "imagine" },
                    { listItem: "look at the big picture" },
                    { listItem: "make intuitive leaps" }
                ],
                audio_link: this.admin_upload + '167/original.mp3?1650372668'
            }, {
                id: 16,
                title: title,
                active: true,
                subtext: "preference:",
                highList: [
                    { listItem: "seek novelty" },
                    { listItem: "see the big picture" },
                    { listItem: "generate lots of ideas" },
                    { listItem: "make connections" },
                    { listItem: "may seem distracted" }
                ],
                neutralList: [
                    { listItem: "generate some ideas" },
                    { listItem: "choose a reasonable option" },
                    { listItem: "move to solutions" }
                ],
                lowList: [
                    { listItem: "move quickly through this stage" },
                    { listItem: "settle on a workable idea" },
                    { listItem: "move to solutions" },
                    { listItem: "may avoid novelty" }
                ],
                audio_link: [
                    this.admin_upload + '168/original.mp3?1650372735',
                    this.admin_upload + '169/original.mp3?1650372776',
                    this.admin_upload + '170/original.mp3?1650372826',
                    this.admin_upload + '171/original.mp3?1650372907',
                ]
            }, {
                id: 17,
                title: title,
                active: true,
                subtext: "This is the stage when you:",
                list: [
                    { listItem: "create workable solutions" },
                    { listItem: "examine pros and cons" },
                    { listItem: "optimize solutions" },
                    { listItem: "make plans" }
                ],
                audio_link: this.admin_upload + '172/original.mp3?1650428820'
            }, {
                id: 18,
                title: title,
                active: true,
                subtext: "preference:",
                highList: [
                    { listItem: "refine and polish solutions" },
                    { listItem: "take time to improve" },
                    { listItem: "craft complex solutions" },
                    { listItem: "can get stuck perfecting solutions" }
                ],
                neutralList: [
                    { listItem: "keep plans simple" },
                    { listItem: "don\u2019t get fixed on perfection" },
                    { listItem: "move into action" }
                ],
                lowList: [
                    { listItem: "keep plans simple" },
                    { listItem: "don\u2019t get fixed on perfection" },
                    { listItem: "move into action" }
                ],
                audio_link: [
                    this.admin_upload + '173/original.mp3?1650428974',
                    this.admin_upload + '174/original.mp3?1650429102',
                    this.admin_upload + '175/original.mp3?1650429164',
                    this.admin_upload + '176/original.mp3?1650429254',
                ]
            }, {
                id: 19,
                title: title,
                active: true,
                subtext: "This is the stage when you:",
                list: [
                    { listItem: "make things happen" },
                    { listItem: "Just do it!" },
                    { listItem: "learn as you go" },
                    { listItem: "focus on results" }
                ],
                audio_link: this.admin_upload + '177/original.mp3?1650429371'
            }, {
                id: 20,
                title: title,
                active: true,
                subtext: "preference:",
                highList: [
                    { listItem: "push toward action" },
                    { listItem: "learn as you go" },
                    { listItem: "persist" },
                    { listItem: "may take action too soon" }
                ],
                neutralList: [
                    { listItem: "move to action when it\u2019s time" },
                    { listItem: "think before acting" },
                    { listItem: "get things done over time" }
                ],
                lowList: [
                    { listItem: "act when necessary" },
                    { listItem: "not rushed" },
                    { listItem: "think first" },
                    { listItem: "may resist taking action" }
                ],
                audio_link: [
                    this.admin_upload + '178/original.mp3?1650429450',
                    this.admin_upload + '179/original.mp3?1650429560',
                    this.admin_upload + '180/original.mp3?1650429608',
                    this.admin_upload + '181/original.mp3?1650429681',
                ]
            }, {
                id: 21,
                title: title,
                active: true,
                audio_link: this.admin_upload + '182/original.mp3?1650429825',
            }, {
                id: 22,
                title: title,
                active: true,
                audio_link: [
                    '',
                    this.admin_upload + '183/original.mp3?1650429956',
                    this.admin_upload + '184/original.mp3?1650430059',
                    this.admin_upload + '185/original.mp3?1650430181',
                    this.admin_upload + '186/original.mp3?1650430291',
                    this.admin_upload + '187/original.mp3?1650430370',
                    this.admin_upload + '188/original.mp3?1650430513',
                    this.admin_upload + '189/original.mp3?1650430567',
                    this.admin_upload + '190/original.mp3?1650430674',
                    this.admin_upload + '191/original.mp3?1650430747',
                    this.admin_upload + '192/original.mp3?1650430834',
                    this.admin_upload + '193/original.mp3?1650430945',
                    this.admin_upload + '194/original.mp3?1650431024',
                    this.admin_upload + '195/original.mp3?1650431134',
                    this.admin_upload + '196/original.mp3?1650431245',
                    this.admin_upload + '197/original.mp3?1650431359',
                ]
            }, {
                id: 23,
                title: title,
                slideBackgroundImage: "f-now.png",
                active: true,
                audio_link: this.admin_upload + '198/original.mp3?1650431479'
            }, {
                id: 24,
                title: title,
                active: true,
                audio_link: this.admin_upload + '199/original.mp3?1650431546',
            }, {
                id: 25,
                title: title,
                slideImage: 'learner-maps/collab-profile.jpg',
                active: true,
                audio_link: this.admin_upload + '200/original.mp3?1650431856'
            }, {
                id: 26,
                title: title,
                slideBackgroundImage: "f-end.png",
                subtext: 'Congratulations',
                profileText: 'Your FourSight profile is',
                active: true,
                audio_link: this.admin_upload + '201/original.mp3?1650431963'
            }, {
                id: 27,
                title: title,
                active: true
            }, {
                id: 28,
                slideBackgroundImage: "",
                subtext: '',
                title: title,
                video_link: this.str(this.currentlm?.link),
                active: true
            }, {
                id: 29,
                title: title,
                imgLink: this.str(this.currentlm?.background),
                slideBackgroundImage: "",
                subtext: '',
                profileText: '',
                active: true,
            }, {
                id: 30,
                title: title,
                video_link: this.str(this.currentlm?.link),
                slideBackgroundImage: "",
                poster: this.str(this.currentlm?.bg),
                subtext: '',
                profileText: '',
                active: true,
            }, {
                id: 31,
                title: title,
                video_link: this.str(this.currentlm?.link),
                slideBackgroundImage: "",
                subtext: '',
                profileText: '',
                active: true,
            }
        ];
    }
}
